import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, InputNumber, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  useCreateOutputPrice,
  useGetOutputPriceById,
  useGetWarehouseById,
  useUpdateOutputPrice,
  useWarehouseList,
} from "../../api/admin";
import { useProductList } from "../../api/product";
import create from "@ant-design/icons/lib/components/IconFont";

type OutputPriceModalProps = {
  open: boolean;
  selectedId?: number;
  hideModal: () => void;
};

const OutputPriceModal: React.FC<OutputPriceModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const [contractPrice, setContractPrice] = useState<number>();
  const [spotPrice, setSpotPrice] = useState<number>();
  const [selectedProductId, setSelectedProductId] = useState<number>();
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>();
  const [year, setYear] = useState<number>();
  const [years, setYears] = useState<number[]>([]);
  const [priceCycle, setPriceCycpe] = useState<number>();

  const { data: selectedOutputPrice, refetch } =
    useGetOutputPriceById(selectedId);
  const { mutateAsync: createOutputPrice, isPending: creating } =
    useCreateOutputPrice();
  const { mutateAsync: updateOutputPrice, isPending: updating } =
    useUpdateOutputPrice();

  const { data: products } = useProductList();
  const { data: warehouses } = useWarehouseList();

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const _years = [];

    for (let y = currentYear; y >= currentYear - 5; y--) {
      _years.push(y);
    }

    setYears(_years);
  }, []);

  useEffect(() => {
    if (selectedId) {
      refetch();
    } else {
      resetForm();
    }
  }, [selectedId]);

  useEffect(() => {
    if (
      selectedOutputPrice &&
      selectedOutputPrice.data &&
      selectedOutputPrice.data.data
    ) {
      setSelectedProductId(selectedOutputPrice.data.data.outPut.id);
      setSelectedWarehouseId(selectedOutputPrice.data.data.warehouse.id);
      setYear(selectedOutputPrice.data.data.year);
      setPriceCycpe(selectedOutputPrice.data.data.priceCycle);
      setSpotPrice(selectedOutputPrice.data.data.spotPrice);
      setContractPrice(selectedOutputPrice.data.data.contractPrice);
    }
  }, [selectedOutputPrice]);

  const onsubmit = async () => {
    if (selectedId === undefined) {
      try {
        if (
          selectedProductId &&
          selectedWarehouseId &&
          priceCycle &&
          contractPrice &&
          spotPrice &&
          year
        ) {
          const data = {
            outPutId: selectedProductId,
            warehouseId: selectedWarehouseId,
            priceCycle,
            contractPrice,
            spotPrice,
            year,
          };

          const result = await createOutputPrice(data);

          if (result && result.status === 200) {
            message.success("Price created successfully");
          }
        }
      } catch (err: any) {
        message.error("Operation failed");
      }
    } else {
      try {
        const data = {
          id: selectedId,
          price: {
            outPutId: selectedProductId,
            warehouseId: selectedWarehouseId,
            priceCycle,
            contractPrice,
            spotPrice,
            year,
          },
        };
        const result = await updateOutputPrice(data);

        if (result && result.data && result.data.data && result.data.data.id) {
          message.success("Price updated successfully");
        }
      } catch (err: any) {
        message.error("Operation failed");
      }
    }
    hideModal();
  };

  const resetForm = () => {};
  return (
    <Modal
      afterClose={resetForm}
      destroyOnClose={true}
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId !== undefined
            ? "Edit Output Product Price"
            : "Create Output Product Price"}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      // okText={isPending ? 'Saving...' : 'Ok'}
      okButtonProps={{
        disabled: creating || updating,
        loading: creating || updating,
      }}
      onCancel={hideModal}
      closable
    >
      <div className="flex flex-col gap-4">
        <Select
          value={selectedProductId}
          placeholder="Select product"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedProductId(Number(val))}
          options={products?.data?.data?.content?.map((item: any) => {
            return { label: item.productName, value: item.id, key: item.id };
          })}
        />
        <Select
          value={selectedWarehouseId}
          placeholder="Select Center"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedWarehouseId(Number(val))}
          options={warehouses?.data?.data?.map((item: any) => {
            return { label: item.centerName, value: item.id, key: item.id };
          })}
        />
        <Select
          value={year}
          placeholder="Select Year"
          style={{ width: "100%" }}
          onChange={(val: any) => setYear(Number(val))}
          options={years.map((item: any) => {
            return { label: item, value: item, key: item };
          })}
        />
        <Select
          value={priceCycle}
          placeholder="Select Price Cycle"
          style={{ width: "100%" }}
          onChange={(val: any) => setPriceCycpe(Number(val))}
          options={[
            { key: 1, value: 1, label: "JANUARY-MARCH" },
            { key: 2, value: 2, label: "APRIL-JUN" },
            { key: 3, value: 3, label: "JULY-SEPTEMBER" },
            { key: 4, value: 4, label: "OCTOBER-DECEMBER" },
          ].map((item: any) => {
            return { label: item.label, value: item.value };
          })}
        />
        <InputNumber
          className="w-full"
          placeholder="Insert contract price"
          value={contractPrice}
          onChange={(e) => setContractPrice(e ?? 0)}
        />
        <InputNumber
          className="w-full"
          placeholder="Insert spot price"
          value={spotPrice}
          onChange={(e) => setSpotPrice(e ?? 0)}
        />
      </div>
    </Modal>
  );
};

export default OutputPriceModal;
